import { useCallback, useEffect, useState } from "react";
import { container } from "tsyringe";
import ContributorResponseResource from "common/resources/Project/Config/Contributor/ContributorResponseResource";
import ContributorService from "services/projects/ContributorService";
import { useProjectId } from "hooks/useProjectId";
import { useProjectTeamContext } from "../contexts/ProjectTeam";

const contributorService = container.resolve(ContributorService);

export const useContributor = (contributor: Pick<ContributorResponseResource, "id" | "projectTeam" | "avatar">) => {
	const { projectId } = useProjectId();
	const { projectTeamId } = useProjectTeamContext();

	const [avatarUrl, setAvatarUrl] = useState<string | null>(null);
	const [avatarFile, setAvatarFile] = useState<File | null>(null);

	const clearAvatar = useCallback(() => {
		setAvatarUrl(null);
		setAvatarFile(null);
	}, []);

	const fetchContributorAvatar = useCallback(() => {
		const { avatar } = contributor;

		if (!avatar) return clearAvatar();

		contributorService.downloadAvatar(projectId, projectTeamId, contributor.id).then((blob) => {
			if (!blob) return clearAvatar();

			setAvatarUrl(URL.createObjectURL(blob));
			setAvatarFile(
				new File([blob], avatar.name ?? "Avatar", {
					type: blob?.type || avatar.mimeType,
				}),
			);
		});
	}, [clearAvatar, contributor, projectId, projectTeamId]);

	useEffect(() => {
		fetchContributorAvatar();
	}, [fetchContributorAvatar]);

	return { avatarUrl, avatarFile };
};
